import React, { useEffect, useState } from 'react';
import { Button, message, Space, Table } from 'antd';
import { Adminauthcontexthooks } from '../../Hooks/Adminauthcontexthooks';


const Firlinkstable = () => {
    const columns = [
        {
            title: 'Fir Sate Name',
            dataIndex: 'firstate',
            key: 'firstate',
            render: text => <p>{text}</p>,
        },
        {
            title: 'Fir Links',
            dataIndex: 'firlink',
            key: 'firlink',
            render: text => <a
                href={text}
                target="_blank"
                rel="noopener noreferrer"
            >
                Fir Link
            </a>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_id, record) => (
                <Space size="middle">
                    <Button color="red" variant="dashed" loading={subbtnloading} onClick={() => Delfirlink(_id)} disabled={subbtnloading}>Delete</Button>
                </Space>
            ),
        },
    ];
    const { user } = Adminauthcontexthooks();
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const [subbtnloading, setsubbtnloading] = useState(false);

    const GetFirLinks = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/firlinks', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
        const data = await res.json();
        if (res.status === 200) {
            setdata(data.FirlinksOBJ);
            setloading(false);
        }
    }

    const Delfirlink = async (obj) => {
        const id = obj._id
        setsubbtnloading(true);
        const res = await fetch(`https://cdr-backend.onrender.com/delete/firlinks/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        //const data = await res.json();
        if (res.status === 200) {
            message.success("Fir Link deleted successfully");
            setsubbtnloading(false);
            GetFirLinks();
            return;
        } else {
            message.error("Something went wrong");
            setsubbtnloading(false);
            return;
        }
    }

    useEffect(() => {
        if (user) {
            const GetFirLinks = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/firlinks', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }

                });
                const data = await res.json();
                if (res.status === 200) {
                    setdata(data.FirlinksOBJ);
                    setloading(false);
                }
            }
            GetFirLinks()
        }
    }, [data, user])
    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} size='small'/>
        </>
    )
}

export default Firlinkstable;